import Tooltip from "../../../../Components/ToolTip";
import BtnRounded from "../../../../../../Components/Buttons/BtnRounded";

import {  FaFileInvoiceDollar } from "react-icons/fa";

const InvoiceTip = ({ open = false, active = false, handlePrint }) => {

  const id = "invoice-tooltip";

  return (
    <div data-tip data-for={id} className="w-full">
      <BtnRounded
        
        click={handlePrint}
      >
        <FaFileInvoiceDollar />
      </BtnRounded>
      <Tooltip
        id={id}
        txt1="Print Invoice"
        txt2=""
      >
        <FaFileInvoiceDollar />
      </Tooltip>
    </div>
  );
};

export default InvoiceTip;
